import { render, staticRenderFns } from "./TabsWithRoutesNew.vue?vue&type=template&id=4972a2be"
import script from "./TabsWithRoutesNew.vue?vue&type=script&lang=ts"
export * from "./TabsWithRoutesNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4972a2be')) {
      api.createRecord('4972a2be', component.options)
    } else {
      api.reload('4972a2be', component.options)
    }
    module.hot.accept("./TabsWithRoutesNew.vue?vue&type=template&id=4972a2be", function () {
      api.rerender('4972a2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabsWithRoutesNew.vue"
export default component.exports